/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".search-list[_ngcontent-%COMP%]{border:1px solid #e4e4e4;position:absolute;left:15px;right:15px;padding-top:10px;background:#fff;overflow-y:scroll;max-height:300px;z-index:1000;line-height:.7em}.shb-coverage[_ngcontent-%COMP%]{list-style:none}.shb-coverage[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;margin-left:11px}.shb-coverage[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:underline}.a-selected[_ngcontent-%COMP%]{font-weight:700}.section[_ngcontent-%COMP%]{padding-left:20px}"];
export { styles as styles };
